import { PageInteractionsEntity } from "@jackfruit/common"
import React from "react"
import FloatingActionButton from "./FloatingActionButton"

interface Props {
  pageInteractions: PageInteractionsEntity[]
}

const FloatingActions: React.FC<Props> = ({ pageInteractions }) => {
  return (
    <>
      {pageInteractions.map(interaction => {
        return (
          <FloatingActionButton
            key={interaction.id}
            showOnBlockIds={interaction.activationBlocks}
            isAlwaysVisible={interaction.isAlwaysVisible}
            htmlBody={interaction.htmlBody}
          />
        )
      })}
    </>
  )
}

export default FloatingActions
